import styled from 'styled-components';
import { typography } from '@/styles/helpers';

export const ScInfoTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 308px;
`;

export const ScInfoTooltipText = styled.p`
  margin: 0;
  ${typography.body2regular};
  color: ${({ theme }) => theme.blackColor};
`;

export const ScInfoIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  cursor: pointer;
`;
